import mapActions from './mapActions';

export default mapActions('material_types');
